/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import { ITextProps, Text } from '@fluentui/react/lib/Text';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';
import { getScopedTheme, getStylist } from 'src/core/themes/luisStylist';

const { styleComponent, styleDiv, getClassName } = getStylist('HomePageScenarios');

export const scenariosTheme = getScopedTheme('HomePageScenarios');

export const ScenariosRootContainer = styleDiv<{ isLargeScreen: boolean }>(
    'HomePageScenariosRootContainer',
    theme => ({
        backgroundColor: theme.containerBackgroundColor
    }),
    ({ customProps }, theme) => ({
        padding: customProps.isLargeScreen ? theme.containerPaddingLarge : theme.containerPaddingSmall
    })
);

export const ScenariosTitle = styleComponent<ITextProps>(Text)('HomePageScenariosTitle', theme => ({
    fontSize: theme.titleFontSize,
    textAlign: 'center'
}));

export const ScenarioSection = styleComponent<IStackProps>(Stack)('HomePageScenarioSection', theme => ({
    padding: theme.scenarioSectionPadding,
    borderBottom: theme.scenarioSectionBorderBottom
}));

export const ScenarioDescription = styleComponent<LuisTextProps>(LuisText)('ScenarioDescription', theme => ({
    lineHeight: theme.descriptionLineSpacing,
    textAlign: 'center'
}));

export const ScenarioBullet = styleComponent<LuisTextProps>(LuisText)('ScenarioDescription', theme => ({
    lineHeight: theme.descriptionLineSpacing
}));

export const ScenarioQuote = styleComponent<LuisTextProps>(LuisText)('ScenarioQuote', theme => ({
    lineHeight: theme.descriptionLineSpacing,
    textAlign: 'center'
}));

export const scenarioImageClassName = getClassName('ScenarioImage', { maxWidth: '95%' });

export const HalfWidthStack = styleComponent<IStackProps>(Stack)<{ isLargeScreen: boolean }>(
    'HalfWidthStackItem',
    {},
    ({ customProps }) => ({
        width: customProps.isLargeScreen ? '50%' : '100%'
    })
);

export const Bullet = styleComponent<IStackProps>(Stack)('ScenarioBulletPoint', theme => ({
    backgroundColor: theme.bulletBackgroundColor,
    minWidth: theme.bulletDim,
    maxWidth: theme.bulletDim,
    minHeight: theme.bulletDim,
    maxHeight: theme.bulletDim,
    borderRadius: '50%'
}));
